import {makeStyles} from "@material-ui/core";
import radioDefImg from "../../../assets/images/map/bttn_radio_def.png";
import radioHoverImg from "../../../assets/images/map/bttn_radio_hover.png";

const useStyles = makeStyles((theme) => ({
    containerWrapper: {
        margin: '0px auto',
        maxWidth: '1180px',
        //minWidth: '900px',
        width: '100%',

        '@media (min-width: 900px) and (max-width: 1200px)': {
            paddingLeft: 15,
            paddingRight: 15
        },

        '@media (max-width:900px)': {
            paddingBottom: '0px',
            paddingTop: '8px',
        },
    },
    containerWrapperFrame: {
        margin: '0px auto',
        minWidth: '900px',
        backgroundImage: `white`,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',

        '@media (min-width: 900px) and (max-width: 1200px)': {
            paddingLeft: 15,
            paddingRight: 15
        },

        '@media (max-width:900px)': {
            paddingBottom: '0px',
            paddingTop: '8px',
        },
    },
    rootPoints: {
        width: '100%',
        // minHeight: '100%',
    },
    searchButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        // borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
    },
    errorMessage: {
        textAlign: 'center',
    },
    noConnection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    autoComplete: {
        boxSizing: 'content-box',
        width: '100%',
        padding: '0px !important',
        backgroundColor: 'white',
        borderRadius: 18,
        '& div': {
            borderRadius: 18
        },
        '@media (max-width:900px)': {
            minWidth: '100%',
        },
    },
    autoCompleteRegion: {
        boxSizing: 'content-box',
        width: '100%',
        padding: '0px !important',
        backgroundColor: 'white',
        borderRadius: 18,
        '& div': {
            borderRadius: 18
        },
    },
    autoCompleteInput: {
        paddingTop: '8.5px !important',
        paddingBottom: '8.5px !important',
        paddingLeft: '25px !important',
        color: theme.palette.colors.text,
        fontSize: 14,
    },
    noPunkts: {
        textAlign: 'center',
    },
    mapWrapper: {
        height: 500,
        borderRadius: '10px 10px 0px 0px',
        overflow: 'hidden',
        // '& .gmnoprint': {
        //     display: 'none',
        // },
        '& .gm-style-mtc': {
            display: 'none',
        },
        '@media (max-width: 900px)': {
            height: 350,
        },
    },
    markerWrapper: {
        background: "transparent",
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    popper: {
        background: 'white',
        borderRadius: '10px',
        boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.75)',
        padding: theme.spacing(2),
        zIndex: '2',
        width: 280,
    },
    markerImage: {
        cursor: "pointer",
        height: '59px',
        width: '34px'
    },
    popperAddress: {
        color: theme.palette.primary.dark,
        fontSize: '16px',
        fontWeight: 600
    },
    mainCell: {
        color: theme.palette.secondary.main,
        borderBottom: 'none',
        paddingBottom: 3,
        fontFamily: "'OpenSans-Regular'",
        fontWeight: 600,
    },
    imgSelectPoint: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 25,
    },
    wrapperStreetDesktop: {
        marginRight: 'auto',
    },
    collectionPointsWrapperMap: {
        height: 415,
        position: 'relative',
        overflow: 'auto',
        scrollbarWidth: 'none',
        '@media (max-width:900px)': {
            height: 'calc(100vh - 220px)',
            maxWidth: '100vw',
        },
        '&::-webkit-scrollbar': {
            width: 5,
        },

        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 5px #363D4D14',
            borderRadius: 10,
        },

        '&::-webkit-scrollbar-thumb': {
            background: theme.palette.colors.main,
            borderRadius: 10,
        },
    },
    filterText: {
        color: theme.palette.colors.text,
        fontSize: '1.25rem',
    },
    accordionWrapperHeader: {
        paddingLeft: 15,
        display: 'grid',
        width: '100%',
        gridTemplateColumns: '416px 38px 38px 38px 38px',
        // gridTemplateColumns: '51.13% 38px 38px 38px 38px',
        '@media (min-width: 900px) and (max-width: 1200px)': {
            gridTemplateColumns: '300px 38px 38px 38px 38px',
        },

        gridColumnGap: '1.5rem',
        '& p': {
            display: 'block',
            textAlign: 'center',
            marginBottom: 11,
        },
        '@media (max-width: 900px)': {
            display: 'none',
        }
    },
    accordionRoot: {
        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        marginLeft: 2,
        // marginTop: 2,
        padding: '15px 20px 5px 20px',
        borderRadius: '10px 0px 0px 0px',
        background: '#ffffff',
    },
    accordionItemTitle: {
        fontWeight: 500,
        color: '#363D4D',
    },
    popperAddressWrapper: {
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        justifyContent: 'space-between',
        maxWidth: 231,
        marginBottom: 9,
    },
    popperMarkerCloseButton: {
        position: 'relative',
        padding: 7,
        left: 7,
    },
    SwipeStyledButton: {
        marginTop: 15,
    },
    inputWrapperRegion: {
        width: '100%',
        "& label": {
            top: -10,
            fontSize: 14,
            color: theme.palette.colors.text,
        },
        '& fieldset': {
            border: '2px solid #F0F0F0 ',
        },
        '& p': {
            // width: 280,
            display: 'flex',
            alignItems: 'center',
        },
    },
    autoCompleteRegionImgSelected: {
        background: `url(${radioDefImg})`,
        height: 15,
        width: 15,
        display: 'block',
    },
    autoCompleteRegionOpthion: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&:hover': {
            '& $autoCompleteRegionImgSelected': {
                background: `url(${radioHoverImg})`,
            },
        }
    },
    // inputWrapperRegionRoot: {
    //     '@media (max-width:900px)': {
    //         display: 'none',
    //     },
    // },
    endAdornmentInput: {
        height: 33,
        display: 'flex',
        alignItems: 'center',
    },

    // dialog styles

    inputRoot: {
        fontWeight: 600,
        padding: '10px',
        borderBottom: 'none',
        backgroundColor: '#f6f5f5',
    },
    describeInput: {
        padding: '10px',
        border: `1px solid #e8e8e8`,
        backgroundColor: "white",
    },
    inputLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '12px',
        fontWeight: 500,
        margin: '10px'
    },
    itemContainer: {
        backgroundColor: '#f6f5f5',
        margin: theme.spacing(1)
    },
    orderContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 4fr 4fr',
        height: '40px',
    },
    serviceContainer: {
        display: 'grid',
        gridTemplateColumns: '6fr 1.5fr',
        margin: '10px 0px',
        position: 'relative'
    },
    columnLabelsContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 4fr 4fr',
        height: '15px',
    },
    serviceLabelsContainer: {
        display: 'grid',
        gridTemplateColumns: '6fr 1.5fr',
        height: '15px',
    },
    columnLabel: {
        fontSize: '12px',
        fontWeight: 500,
        color: theme.palette.grey.text
    },
    orderDetailLabel: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600
    },
    dialogContainer: {
        '& .MuiPaper-rounded': {
            borderRadius: '20px'
        },
    },
    dialogContent: {
        margin: '30px 30px 0px 30px',
        '@media(max-width: 900px)': {
            margin: '10px 0px 0px 0px'
        }
    },
    codeBlock: {
        padding: '30px',
        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
        borderRadius: '20px',
        width: 'min-content',
        margin: 'auto'
    },
    dialogTitle: {
        backgroundColor: theme.palette.primary.dark,
        textAlign: 'center',
        color: 'white',
    },
    dialogText: {
        fontWeight: '500',
        fontSize: '15px',
        //width: '40%',
        '@media(max-width: 600px': {
            width: '80%'
        },
        textAlign: 'center',
        marginTop: '30px'
    },
}));

export default useStyles;